import React from 'react';
import { ErrorCircle12Filled } from '@fluentui/react-icons';

import {
    describeCurrencyIssue,
    formatCurrencyAmount,
    inspectCurrency,
    shortCurrencyIssueLabel,
} from '../../currency/Currency.Functions';

import './CurrencyAmount.Styles.css';

interface IProps {
    amount: number | undefined | null;
    currency: string | undefined | null;
    /** Se agrega al contenedor, para que cada grilla conserve su tipografía. */
    className?: string;
}

/**
 * Importe con moneda. Cuando la moneda falta o no es un código ISO válido lo
 * marca en pantalla en vez de disimularlo: el importe se sigue leyendo, pero
 * queda claro que el dato está incompleto y cuál es el valor que vino mal.
 */
export const CurrencyAmountComponent = (props: IProps) => {

    const inspection = inspectCurrency(props.currency);
    const text = formatCurrencyAmount(props.amount, props.currency);

    if (!inspection.issue) {
        return <span className={`currencyAmount ${props.className ?? ''}`.trim()}>{text}</span>;
    }

    const message = describeCurrencyIssue(inspection);

    return (
        <span
            className={`currencyAmount currencyAmount--issue ${props.className ?? ''}`.trim()}
            title={message}
        >
            <ErrorCircle12Filled className='currencyAmount__icon' aria-hidden />
            <span>{text}</span>
            <span className='currencyAmount__issueLabel'>{shortCurrencyIssueLabel(inspection)}</span>
            <span className='currencyAmount__srOnly'>{message}</span>
        </span>
    );
};

export default CurrencyAmountComponent;
